import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PeopleIcon } from '@repo/custom-icons';
import { organization_people_path } from '@repo/routes';
import { cn } from '@repo/ui-primitives/utils';
import { BackgroundCard } from '../BackgroundCard';
import { Link } from '../Link';
import { AvatarList } from '../card-item-elements';
function PeopleCard(param) {
    let { peopleList, organizationName, title, moreLink, moreLinkDisabled } = param;
    return /*#__PURE__*/ _jsx(BackgroundCard, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col w-full max-w-[17.625rem] bg-card rounded-lg p-1 text-sm text-muted-foreground",
            "data-e2e": "people-card",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between gap-2 [&>h3]:font-medium [&>h3]:text-base [&>h3]:text-foreground [&>h3]:m-0",
                    "data-e2e": "people-card-header",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            children: title !== null && title !== void 0 ? title : 'People'
                        }),
                        !moreLinkDisabled && /*#__PURE__*/ _jsx(Link, {
                            className: "white",
                            to: moreLink !== null && moreLink !== void 0 ? moreLink : organization_people_path({
                                organization: {
                                    name: organizationName
                                }
                            }),
                            children: "Show more"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-1 mt-1",
                    "data-e2e": "people-card-members-count",
                    children: [
                        /*#__PURE__*/ _jsx(PeopleIcon, {
                            color: "#27584D",
                            width: 18,
                            height: 18
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                peopleList.length,
                                " ",
                                peopleList.length > 1 ? 'members' : 'member'
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn('flex gap-2 mt-4'),
                    "data-e2e": "people-card-avatar-list",
                    children: /*#__PURE__*/ _jsx(AvatarList, {
                        list: peopleList,
                        showAmount: 6
                    })
                })
            ]
        })
    });
}
export { PeopleCard };
